<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ pageTitle() }}</h2>
      <p>Onboard an insured member and their nominees, then verify via OTP to complete KYC.</p>
    </div>
  </div>

  <div class="card">
    <p-stepper [(value)]="activeStep" [linear]="true" styleClass="member-stepper">
      <p-step-list>
        <p-step [value]="1">Premium &amp; Member Details</p-step>
        <p-step [value]="2">Nominee Details</p-step>
        <p-step [value]="3">OTP Verification</p-step>
        <p-step [value]="4">Payment</p-step>
      </p-step-list>

      <p-step-panels>
        <!-- ===================== STEP 1 ===================== -->
        <p-step-panel [value]="1">
          <ng-template #content>
            <app-member-details-step
              [form]="form"
              [premiumRuleOptions]="premiumRuleOptions()"
              [genderOptions]="genderOptions"
              [selectedRule]="selectedRule()"
              [memberUniqueId]="memberUniqueId()" />

            <div class="wizard-actions">
              <span></span>
              <p-button label="Next" icon="pi pi-arrow-right" iconPos="right"
                (onClick)="goToNominees()" />
            </div>
          </ng-template>
        </p-step-panel>

        <!-- ===================== STEP 2 ===================== -->
        <p-step-panel [value]="2">
          <ng-template #content>
            <app-nominee-details-step
              [nominees]="nominees"
              [relationshipOptions]="relationshipOptions()"
              (addNominee)="addNominee()"
              (removeNominee)="removeNominee($event)"
              (sameAsMemberToggle)="onNomineeSameToggle($event)" />

            <div class="wizard-actions">
              <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" [outlined]="true"
                (onClick)="back(1)" />
              <p-button label="Save &amp; Continue" icon="pi pi-check" iconPos="right"
                (onClick)="save()" [loading]="saving()" />
            </div>
          </ng-template>
        </p-step-panel>

        <!-- ===================== STEP 3 ===================== -->
        <p-step-panel [value]="3">
          <ng-template #content>
            @if (memberUniqueId() || memberSeriesNo()) {
              <div class="uid-banner">
                <i class="pi pi-id-card"></i>
                Member created
                @if (memberUniqueId()) { — ID <b>{{ memberUniqueId() }}</b> }
                @if (memberSeriesNo()) { · Series <b>{{ memberSeriesNo() }}</b> }
                @if (masterPolicyOnLoan()) { · Loan ID <b>{{ masterPolicyOnLoan() }}</b> }
              </div>
            }
            @if (memberId(); as mid) {
              <app-otp-step
                [memberId]="mid"
                [channels]="channels()"
                [expiresInMinutes]="expiresInMinutes()"
                [otpSent]="otpSent()"
                [otpMessage]="otpMessage()"
                (verified)="onVerified()" />
            }
          </ng-template>
        </p-step-panel>

        <!-- ===================== STEP 4 — PAYMENT ===================== -->
        <p-step-panel [value]="4">
          <ng-template #content>
            @if (memberUniqueId() || memberSeriesNo()) {
              <div class="uid-banner">
                <i class="pi pi-id-card"></i>
                Member verified
                @if (memberUniqueId()) { — ID <b>{{ memberUniqueId() }}</b> }
                @if (masterPolicyOnLoan()) { · Loan ID <b>{{ masterPolicyOnLoan() }}</b> }
              </div>
            }
            @if (memberId(); as mid) {
              <app-member-payment-step
                [memberId]="mid"
                [memberUniqueId]="memberUniqueId()"
                [amount]="grossAmt()"
                [summary]="paymentSummary()"
                [memberName]="prefillName()"
                [memberEmail]="form.get('email')?.value"
                [memberMobile]="form.get('mobileNumber')?.value"
                (restart)="restart()" />
            }
          </ng-template>
        </p-step-panel>
      </p-step-panels>
    </p-stepper>
  </div>
</div>
